export default __webpack_public_path__ + "assets/eb8a15a2d1ffdd08b50620a9b1c459eb.png";